import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { BeforeYouGoActionWidgets } from "./before-you-go-action-widget";

export const StyledBeforeYouGoActionWidgets = styled(BeforeYouGoActionWidgets)`
  margin-block-start: 12px;
`;

export const Title = styled.div`
  margin-block-end: 8px;

  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;
  margin-block: 12px 8px;

  background: #dfdfdf;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column;

  padding-block: 16px 8px;
  padding-inline: 16px;

  border: 1px solid #dfdfdf;
  border-radius: 8px;

  background-color: #ffffff;

  ${theme.breakpoints.down("desktop")} {
    inline-size: 280px;
    block-size: 100%;
    min-inline-size: 280px;
  }
`;
